import {t} from 'i18next';
import React from 'react';
import AAIEduLogo from '../../../../assets/images/logos/aaiEduLogo.png';
import {aaiEduOidcService} from '../../../service/oidc.service';
import Button from '../../../incase-domain/components/button/Button';

function AAIEduLoginButton(): JSX.Element {
    const handleLogin = (): void => {
        aaiEduOidcService.login();
    };

    return (
        <Button variant="soft" color="primary" size="md" onClick={handleLogin} dataCy="aaiedu_login_button">
            <img className="c-aaiEduButton__logo" src={AAIEduLogo} alt="aaiedu logo" />
            {t('form.aaiEdu')}
        </Button>
    );
}

export default AAIEduLoginButton;
